document.documentElement.classList.add('js');
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  const mobileToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.getElementById('MobileMenu');
  const navTriggers = document.querySelectorAll('.nav-trigger');
  const closeMegaMenus = (except) => navTriggers.forEach((trigger) => {
    if (trigger !== except) { trigger.setAttribute('aria-expanded', 'false'); trigger.closest('.nav-item')?.classList.remove('is-open'); }
  });
  navTriggers.forEach((trigger) => trigger.addEventListener('click', () => {
    const willOpen = trigger.getAttribute('aria-expanded') !== 'true';
    closeMegaMenus(trigger);
    trigger.setAttribute('aria-expanded', String(willOpen));
    trigger.closest('.nav-item')?.classList.toggle('is-open', willOpen);
  }));
  document.addEventListener('click', (event) => { if (!event.target.closest('.nav-item')) closeMegaMenus(); });
  if (mobileToggle && mobileMenu) mobileToggle.addEventListener('click', () => {
    const willOpen = mobileToggle.getAttribute('aria-expanded') !== 'true';
    mobileToggle.setAttribute('aria-expanded', String(willOpen));
    mobileToggle.querySelector('.visually-hidden').textContent = willOpen ? 'Close menu' : 'Open menu';
    mobileMenu.hidden = !willOpen;
    document.body.classList.toggle('menu-open', willOpen);
  });
  const closeMobileMenu = () => {
    if (!mobileToggle || !mobileMenu) return;
    mobileToggle.setAttribute('aria-expanded', 'false');
    mobileToggle.querySelector('.visually-hidden').textContent = 'Open menu';
    mobileMenu.hidden = true;
    document.body.classList.remove('menu-open');
  };
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMegaMenus();
    closeMobileMenu();
    mobileToggle?.focus();
  });
  window.addEventListener('resize', () => {
    if (window.innerWidth > 900) closeMobileMenu();
  }, { passive: true });
  let lastY = 0;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    header?.classList.toggle('is-condensed', y > 70);
    header?.classList.toggle('is-hidden', y > lastY && y > 240 && !document.body.classList.contains('menu-open'));
    lastY = Math.max(y, 0);
  }, { passive: true });
  document.querySelectorAll('[data-ritual-finder]').forEach((finder) => {
    const tabs = [...finder.querySelectorAll('[data-ritual-tab]')];
    const panels = [...finder.querySelectorAll('[data-ritual-panel]')];
    const activate = (tab, scrollToRitual = false) => {
      const id = tab.dataset.ritualTab;
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        const active = panel.dataset.ritualPanel === id;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      if (scrollToRitual && window.matchMedia('(max-width: 620px)').matches) {
        const activePanel = panels.find((panel) => panel.dataset.ritualPanel === id);
        tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        window.setTimeout(() => activePanel?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 120);
      }
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab, true));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowRight','ArrowLeft','ArrowDown','ArrowUp'].includes(event.key)) return;
        event.preventDefault();
        const step = ['ArrowRight','ArrowDown'].includes(event.key) ? 1 : -1;
        const next = tabs[(index + step + tabs.length) % tabs.length];
        activate(next, true);
        next.focus();
      });
    });
  });
  document.querySelectorAll('[data-catalogue]').forEach((catalogue) => {
    const drawer = catalogue.querySelector('[data-filter-drawer]');
    const toggle = catalogue.querySelector('[data-filter-toggle]');
    const close = catalogue.querySelector('[data-filter-close]');
    const backdrop = catalogue.querySelector('[data-filter-backdrop]');
    const setDrawer = (open) => {
      if (!drawer || !toggle || !backdrop) return;
      drawer.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      backdrop.hidden = !open;
      document.body.classList.toggle('filter-open', open);
      if (open) close?.focus();
    };
    toggle?.addEventListener('click', () => setDrawer(true));
    close?.addEventListener('click', () => setDrawer(false));
    backdrop?.addEventListener('click', () => setDrawer(false));
    catalogue.querySelector('[data-sort-select]')?.addEventListener('change', (event) => event.target.form.submit());
    catalogue.addEventListener('keydown', (event) => { if (event.key === 'Escape') setDrawer(false); });
  });
  document.querySelectorAll('[data-product-page]').forEach((page) => {
    const slides = [...page.querySelectorAll('[data-product-slide]')];
    const thumbs = [...page.querySelectorAll('[data-product-thumb]')];
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      const id = thumb.dataset.productThumb;
      thumbs.forEach((item) => { const active = item === thumb; item.classList.toggle('is-active', active); item.setAttribute('aria-pressed', String(active)); });
      slides.forEach((slide) => { const active = slide.dataset.productSlide === id; slide.hidden = !active; slide.classList.toggle('is-active', active); });
    }));
    const quantity = page.querySelector('[data-quantity-input]');
    page.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
    page.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { quantity.value = Number(quantity.value || 1) + 1; });
    page.querySelector('[data-variant-select]')?.addEventListener('change', (event) => {
      const option = event.target.selectedOptions[0];
      const available = option.dataset.available === 'true';
      const price = page.querySelector('[data-product-price]');
      const button = page.querySelector('[data-add-button]');
      const label = page.querySelector('[data-add-label]');
      if (price) price.innerHTML = `${option.dataset.price}${option.dataset.compare && option.dataset.compare !== option.dataset.price ? `<s>${option.dataset.compare}</s>` : ''}`;
      if (button) button.disabled = !available;
      if (label) label.textContent = available ? 'Add to cart' : 'Sold out';
    });
  });
  document.querySelectorAll('.quick-add-form, .premium-product-form').forEach((productForm) => {
    productForm.addEventListener('submit', async (event) => {
      if (productForm.classList.contains('premium-product-form') && !event.submitter?.matches('[data-add-button]')) return;
      event.preventDefault();
      const submitButton = productForm.querySelector('[type="submit"]');
      const originalLabel = submitButton?.innerHTML;
      if (submitButton) { submitButton.disabled = true; submitButton.classList.add('is-adding'); }
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(productForm)
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'This product could not be added to your bag.');
        }
        window.location.assign(`${root}cart`);
      } catch (error) {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('is-adding');
          submitButton.innerHTML = originalLabel;
        }
        productForm.querySelector('[data-product-form-error]')?.remove();
        const message = document.createElement('p');
        message.className = 'product-form-error';
        message.dataset.productFormError = '';
        message.setAttribute('role', 'alert');
        message.textContent = error.message;
        productForm.appendChild(message);
      }
    });
  });
  document.querySelectorAll('[data-cart-page]').forEach((cartPage) => {
    const form = cartPage.querySelector('.premium-cart-form');
    if (!form) return;
    cartPage.querySelectorAll('[data-cart-line]').forEach((line) => {
      const quantity = line.querySelector('[data-cart-quantity]');
      const update = (amount) => {
        if (!quantity) return;
        quantity.value = Math.max(0, Number(quantity.value || 0) + amount);
        cartPage.classList.add('is-updating');
        form.requestSubmit();
      };
      line.querySelector('[data-cart-minus]')?.addEventListener('click', () => update(-1));
      line.querySelector('[data-cart-plus]')?.addEventListener('click', () => update(1));
    });
    form.addEventListener('submit', () => cartPage.classList.add('is-updating'));
  });
  const revealItems = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    }), { threshold: 0.18 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }
});
